(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["international_menu"] && !Shopify.designMode) return;
  try {
    document.querySelector('.close_intermenu').addEventListener('click',function(e){
    document.querySelector('.internation_menu').classList.add("hide");
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section-toolbar"] && !Shopify.designMode) return;
  try {
    document.querySelector('.select_country').addEventListener('click',function(e){
    document.querySelector('.internation_menu').classList.toggle("hide");
  })
  } catch(e) { console.error(e); }
})();

})();
